import { StateCreator } from 'zustand';
import {
  CurrencyCode,
  DEFAULT_CURRENCY,
  normalizeCurrencyCode,
} from '@/shared/constants/currencies';

export type Region = {
  countryISO: string;
  currency: CurrencyCode;
};

export interface CurrencySlice {
  currentCurrency: CurrencyCode;
  countryISO: string | null;
  setRegion: (region: Region) => void;
}

export const createCurrencySlice: StateCreator<CurrencySlice> = (set) => ({
  currentCurrency: DEFAULT_CURRENCY,
  // Null until the geo lookup resolves, so the footer can stay blank rather than
  // claim a country we have not detected yet.
  countryISO: null,
  setRegion: ({ countryISO, currency }) =>
    set({ countryISO, currentCurrency: normalizeCurrencyCode(currency) }),
});
